// The onSubmit handler can return either void or Promise<void | T>, which triggers
// the no-misused-promises rule when passed to form.handleSubmit. This is a false positive
// since react-hook-form properly handles both synchronous and asynchronous submit handlers.
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable react/jsx-props-no-spreading */
import { FormProvider } from 'react-hook-form';
import React from 'react';
import { FormProps } from '../../../types/fileExplorerTypes';
import { ReplaceFileSchema } from './schemas';
import { InputField } from '../../Forms/Fields';
import { DropzoneField } from '../../Forms/Fields/DropzoneField';
import { formsConfig } from './config';

export function ReplaceFileForm({ form, children, onSubmit }: FormProps<ReplaceFileSchema>) {
  const showFileDescription = !form.watch('file');
  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="modal-form">
        <DropzoneField<ReplaceFileSchema>
          name="file"
          label="Archivo"
          accept={formsConfig.commonAcceptedFiles}
          showPreview
        />
        {showFileDescription && (
          <span className="text-sm">Si no provees un nuevo archivo, el archivo actual se mantendrá.</span>
        )}

        <InputField<ReplaceFileSchema>
          id="title"
          path="title"
          label="Nombre"
          placeholder="Nombre del archivo"
          required
        />
        <InputField<ReplaceFileSchema>
          id="description"
          path="description"
          label="Descripción"
          placeholder="Descripción del archivo"
        />
        {children}
      </form>
    </FormProvider>
  );
}
